/* ============================================================
   PET PRINT LAB — FABLE 5 · Premium Size Guide modal  (v1)
   Vanilla JS · zero libraries · ES5-safe · no console errors
   Desktop + iOS + Android + tablet
   ============================================================ */
(function () {
  'use strict';

  var MODAL_ID = 'FableSizeGuide';
  var TRIGGER_SEL = '.fable-sizechart-trigger, [data-fable-sg-open]';
  var INCH_TO_CM = 2.54;

  var overlay = null;
  var lastFocused = null;
  var scrollY = 0;
  var currentUnit = 'in';
  var booted = false;

  /* ---------------- helpers ---------------- */

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function closestEl(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches ? el.matches(selector) : el.msMatchesSelector(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  /* Normalise any size label to one of XS / S / M / L / XL / 2XL / 3XL / 4XL / 5XL */
  var SIZE_MAP = {
    XS: 'XS', 'X-SMALL': 'XS', 'EXTRA SMALL': 'XS', XSMALL: 'XS',
    S: 'S', SM: 'S', SMALL: 'S',
    M: 'M', MED: 'M', MEDIUM: 'M',
    L: 'L', LG: 'L', LARGE: 'L',
    XL: 'XL', XLARGE: 'XL', 'X-LARGE': 'XL', 'EXTRA LARGE': 'XL', '1X': 'XL', '1XL': 'XL',
    '2XL': '2XL', XXL: '2XL', '2X': '2XL', 'XX-LARGE': '2XL', '2X-LARGE': '2XL',
    '3XL': '3XL', XXXL: '3XL', '3X': '3XL', '3X-LARGE': '3XL',
    '4XL': '4XL', XXXXL: '4XL', '4X': '4XL', '4X-LARGE': '4XL',
    '5XL': '5XL', XXXXXL: '5XL', '5X': '5XL', '5X-LARGE': '5XL'
  };

  function normaliseSize(raw) {
    if (!raw) return null;
    var v = String(raw).toUpperCase();
    v = v.replace(new RegExp(String.fromCharCode(160), 'g'), ' ').replace(/\./g, '').replace(/\s+/g, ' ').trim();
    if (SIZE_MAP[v]) return SIZE_MAP[v];
    var squashed = v.replace(/[\s_-]/g, '');
    if (SIZE_MAP[squashed]) return SIZE_MAP[squashed];
    return null;
  }

  function looksLikeSizeName(name) {
    return !!name && /size/i.test(String(name));
  }

  /* ---------------- selected size detection ---------------- */

  function fromSelectedVariantJson() {
    var nodes = document.querySelectorAll('variant-selects script[data-selected-variant]');
    for (var i = 0; i < nodes.length; i++) {
      var data = null;
      try {
        data = JSON.parse(nodes[i].textContent || 'null');
      } catch (e) {
        data = null;
      }
      if (!data) continue;
      var opts = data.options || [data.option1, data.option2, data.option3];
      for (var j = 0; j < opts.length; j++) {
        var hit = normaliseSize(opts[j]);
        if (hit) return hit;
      }
    }
    return null;
  }

  function fromNamedInputs() {
    /* Dawn radio name is "<Option name>-<position>", e.g. "Size-2" */
    var radios = document.querySelectorAll(
      'variant-selects input[type="radio"]:checked, .product-form__input input[type="radio"]:checked'
    );
    var i, el, hit;
    for (i = 0; i < radios.length; i++) {
      el = radios[i];
      if (looksLikeSizeName(el.getAttribute('name'))) {
        hit = normaliseSize(el.value);
        if (hit) return hit;
      }
    }
    var selects = document.querySelectorAll(
      'variant-selects select, .product-form__input select'
    );
    for (i = 0; i < selects.length; i++) {
      el = selects[i];
      if (looksLikeSizeName(el.getAttribute('name'))) {
        hit = normaliseSize(el.value);
        if (hit) return hit;
      }
    }
    /* Legend-based lookup (swatch / pill fieldsets) */
    var fieldsets = document.querySelectorAll('variant-selects fieldset, .product-form__input');
    for (i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend, label.form__label');
      if (!legend || !looksLikeSizeName(legend.textContent)) continue;
      var checked = fieldsets[i].querySelector('input[type="radio"]:checked');
      if (checked) {
        hit = normaliseSize(checked.value);
        if (hit) return hit;
      }
      var sel = fieldsets[i].querySelector('select');
      if (sel) {
        hit = normaliseSize(sel.value);
        if (hit) return hit;
      }
    }
    return null;
  }

  function fromAnyChecked() {
    var nodes = document.querySelectorAll(
      'variant-selects input[type="radio"]:checked, .product-form__input input[type="radio"]:checked'
    );
    for (var i = 0; i < nodes.length; i++) {
      var hit = normaliseSize(nodes[i].value);
      if (hit) return hit;
    }
    var selects = document.querySelectorAll('variant-selects select, .product-form__input select');
    for (var k = 0; k < selects.length; k++) {
      var s = normaliseSize(selects[k].value);
      if (s) return s;
    }
    return null;
  }

  function getSelectedSize() {
    return fromSelectedVariantJson() || fromNamedInputs() || fromAnyChecked();
  }

  /* ---------------- rendering ---------------- */

  function renderUnits() {
    if (!overlay) return;
    var cells = overlay.querySelectorAll('[data-fable-sg-in]');
    for (var i = 0; i < cells.length; i++) {
      var inches = parseFloat(cells[i].getAttribute('data-fable-sg-in'));
      if (isNaN(inches)) continue;
      cells[i].textContent =
        currentUnit === 'cm' ? (inches * INCH_TO_CM).toFixed(1) : inches.toFixed(2);
    }
    var btns = overlay.querySelectorAll('[data-fable-sg-unit]');
    for (var j = 0; j < btns.length; j++) {
      var active = btns[j].getAttribute('data-fable-sg-unit') === currentUnit;
      btns[j].classList.toggle('is-active', active);
      btns[j].setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  function renderSelectedRow() {
    if (!overlay) return;
    var size = getSelectedSize();
    var rows = overlay.querySelectorAll('[data-fable-sg-size]');
    var matched = null;
    for (var i = 0; i < rows.length; i++) {
      var isMatch = size !== null && rows[i].getAttribute('data-fable-sg-size') === size;
      rows[i].classList.toggle('is-selected', isMatch);
      if (isMatch) {
        matched = rows[i];
        rows[i].setAttribute('aria-current', 'true');
      } else {
        rows[i].removeAttribute('aria-current');
      }
    }
    var helper = overlay.querySelector('[data-fable-sg-helper]');
    if (helper) {
      /* The note is this product's own, rendered from its description by
         fable-size-guide.liquid. Never overwrite it with a fixed sentence. */
      var note =
        helper.getAttribute('data-fable-sg-note') ||
        'Between sizes? Choose the larger size for an easier, roomier fit.';
      helper.textContent = matched ? size + ' is highlighted. ' + note : note;
    }
    return matched;
  }

  /* ---------------- scroll lock (iOS-safe) ---------------- */

  function lockScroll() {
    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.top = -scrollY + 'px';
    document.body.style.position = 'fixed';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.classList.add('fable-sg-lock');
  }

  function unlockScroll() {
    document.body.classList.remove('fable-sg-lock');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, scrollY);
  }

  /* ---------------- focus trap ---------------- */

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]),' +
    ' textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function trapFocus(e) {
    if (e.key !== 'Tab' && e.keyCode !== 9) return;
    if (!overlay || overlay.hidden) return;
    var nodes = [];
    var all = overlay.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < all.length; i++) {
      if (all[i].offsetParent !== null || all[i].getClientRects().length) nodes.push(all[i]);
    }
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* ---------------- open / close ---------------- */

  function openModal(trigger) {
    if (!overlay) return;
    lastFocused = trigger || document.activeElement;
    renderSelectedRow();
    renderUnits();
    overlay.hidden = false;
    lockScroll();
    /* double rAF so the transition always runs, even on first paint */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
      });
    });
    var scroller = overlay.querySelector('.fable-sg-scroll') || overlay.querySelector('.fable-sg-modal');
    if (scroller) scroller.scrollTop = 0;
    var closeBtn = overlay.querySelector('.fable-sg-close');
    if (closeBtn) {
      try {
        closeBtn.focus({ preventScroll: true });
      } catch (e) {
        closeBtn.focus();
      }
    }
  }

  function closeModal() {
    if (!overlay || overlay.hidden) return;
    overlay.classList.remove('is-open');
    unlockScroll();
    window.setTimeout(function () {
      overlay.hidden = true;
    }, 200);
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try {
        lastFocused.focus({ preventScroll: true });
      } catch (e) {
        lastFocused.focus();
      }
    }
    lastFocused = null;
  }

  /* ---------------- wiring ---------------- */

  function relocate() {
    /* Escape any transformed / overflow-hidden ancestor so position:fixed
       is always relative to the viewport — critical on mobile Safari. */
    if (overlay && overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }
  }

  function bind() {
    document.addEventListener(
      'click',
      function (e) {
        var trigger = closestEl(e.target, TRIGGER_SEL);
        if (trigger) {
          e.preventDefault();
          if (!overlay) overlay = document.getElementById(MODAL_ID);
          relocate();
          openModal(trigger);
          return;
        }
        if (!overlay || overlay.hidden) return;
        if (closestEl(e.target, '.fable-sg-close')) {
          e.preventDefault();
          closeModal();
          return;
        }
        var unitBtn = closestEl(e.target, '[data-fable-sg-unit]');
        if (unitBtn && overlay.contains(unitBtn)) {
          e.preventDefault();
          currentUnit = unitBtn.getAttribute('data-fable-sg-unit') === 'cm' ? 'cm' : 'in';
          renderUnits();
          return;
        }
        /* click on the backdrop itself (not the panel) closes */
        if (e.target === overlay) closeModal();
      },
      false
    );

    document.addEventListener('keydown', function (e) {
      if (!overlay || overlay.hidden) return;
      if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
        e.preventDefault();
        closeModal();
        return;
      }
      trapFocus(e);
    });

    /* keep the highlighted row in sync with the variant picker */
    var syncTimer = null;
    function scheduleSync() {
      window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(function () {
        if (overlay && !overlay.hidden) renderSelectedRow();
      }, 120);
    }
    document.addEventListener('change', function (e) {
      if (closestEl(e.target, 'variant-selects, variant-radios, .product-form__input')) {
        scheduleSync();
      }
    });
    document.addEventListener('shopify:section:load', function () {
      overlay = document.getElementById(MODAL_ID) || overlay;
      relocate();
      scheduleSync();
    });

    if ('MutationObserver' in window) {
      var host = document.querySelector('variant-selects');
      if (host) {
        try {
          new MutationObserver(scheduleSync).observe(host, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['checked', 'selected', 'value']
          });
        } catch (e) {
          /* noop */
        }
      }
    }
  }

  function init() {
    if (booted) return;
    booted = true;
    overlay = document.getElementById(MODAL_ID);
    relocate();
    renderUnits();
    renderSelectedRow();
    bind();
  }

  ready(init);
})();